export const GET_LIST = 'getList'
export const SET_LIST = 'setList'
export const SET_LENGTH = 'setLength'
export const SET_LIST_LOADING = 'setListLoading'
export const SET_LIST_RENDER = 'setListRender'
